import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import logo from '../img/logo.png'
import { MenuIcon } from '@icons/material'
import classNames from 'classnames'

if (typeof window !== 'undefined') {
  var useWindowScrollPosition = require('@rehooks/window-scroll-position')
} else {
  useWindowScrollPosition = () => ({})
}

const NavWrapper = styled.header`
  position: relative;
  z-index: 10;
  height: 6.5rem;

  @media (max-width: 43rem) {
    height: 4.2rem;
  }
`

const Nav = styled.nav`
  position: fixed;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #f1ef9d;
  top: 0;
  left: 0;
  right: 0;
  transition: top 0.5s ease;

  @media (max-width: 43rem) {
    &,
    &.scrolled {
      top: -17rem;
    }

    &.open {
      top: 0;
    }
  }
`

const NavList = styled.ul`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 2rem;
  margin: 0 auto;
  max-width: 60rem;

  @media (max-width: 43rem) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 4rem;
  }
`

const NavItem = styled.li`
  display: block;
`

const NavLinkString = `
  display: block;
  color: #3b4e57;
  font-family: mr-eaves-modern;
  font-size: 0.9rem;
  letter-spacing: 0.2em;
  padding: 2rem 1em;
  text-decoration: none;
  text-transform: uppercase;

  &.logo {
    margin: 0;
    padding: 0;

    img {
      width: 18.76rem;
      transition: all 0.5s ease;
    }
  }

  .scrolled &.logo img {
    width: 14rem;
  }

  @media (max-width: 43rem) {
    margin: 0;
    padding: 1.6rem;

    &.logo {
      margin: 0;
      padding: 0;
      position: absolute;
      bottom: 0;
      left: 8rem;
      right: 8rem;
      text-align: center;

      img {
        width: 10rem;
      }
    }

    .scrolled &.logo img {
      width: 10rem;
    }
  }
`

const NavLink = styled(Link)`
  ${NavLinkString}
`

const NavA = styled.a`
  ${NavLinkString}
`

const NavItemLink = props => (
  <NavItem>
    {props.type === 'a' ? (
      <NavA
        href={props.to}
        className={props.className}
        children={props.children}
      />
    ) : (
      <NavLink {...props} />
    )}
  </NavItem>
)

const MenuButton = styled.div`
  position: absolute;
  bottom: 0.6rem;
  left: 1.2rem;
  cursor: pointer;
  display: none;

  @media (max-width: 43rem) {
    display: block;
  }
`

const Navbar = () => {
  const links = [
    { name: 'Shop', url: 'https://shop.oneandonlypaper.com/', type: 'a' },
    { name: 'About', url: '/#about', type: 'a' },
    { name: 'Blog', url: '/blog' },
    { name: 'Inquire', url: 'https://oopaperco.typeform.com/to/xFYdSd', type: 'a' },
  ]
  const [menuOpen, setMenuOpen] = useState(false)
  const options = { throttle: 100 }
  const { y } = useWindowScrollPosition(options)
  return (
    <NavWrapper>
      <Nav
        role="navigation"
        aria-label="main-navigation"
        className={classNames({ open: menuOpen, scrolled: y > 100 })}
      >
        <MenuButton onClick={() => setMenuOpen(!menuOpen)}>
          <MenuIcon fill="#3B4E57" width="2.4rem" height="2.5rem" />
        </MenuButton>
        <NavList>
          <NavItemLink className="logo" to="https://shop.oneandonlypaper.com/" key="/" type="a">
            <img src={logo} alt="One &amp; Only Paper" />
          </NavItemLink>
          {links.map(({ name, url, type }) => (
            <NavItemLink key={url} to={url} type={type}>
              {name}
            </NavItemLink>
          ))}
        </NavList>
      </Nav>
    </NavWrapper>
  )
}

export default Navbar
